<template>
  <div v-if="message" :class="{ message_from: !isMine }">
    <Avatar
      v-if="!isMine"
      :pic="user.files_urls.avatar_thumbnail"
      :name="user.name || user.email"
      class="mr-8"
    />
    <div :class="{ message_my: isMine }" class="message">
      <div>
        <CommentMessage
          v-if="message.tender_offer_row_comment"
          :message="message"
          :is-mine="isMine"
        />
        <div v-else>
          <div v-if="user && !isMine" class="message-user">
            {{ user.name }}
          </div>
          <div class="text-sm">
            {{ message.message || message.text }}
          </div>
        </div>
        <div class="message-links">
          <FileLink
            v-for="(file, idx) in message.files"
            :key="idx"
            :name="file.name"
            :overlay="isMine"
            :size="file.size"
            :file-link="get(file, 'files_urls.file', '')"
          />
        </div>
      </div>
      <div class="text-sm">
        <MessageStatus v-if="isMine" :message="message" v-on="$listeners" />
        <div v-else class="message-time">
          {{ time }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';
  import time from '@/utils/date/time';
  import MessageStatus from '@/components/chat/MessageStatus';
  import CommentMessage from '@/components/chat/CommentMessage';
  import get from 'lodash.get';
  import FileLink from '@/components/files/FileLink';

  export default {
    name: 'Message',
    components: {
      Avatar,
      FileLink,
      MessageStatus,
      CommentMessage,
    },
    props: {
      userId: {
        type: Number,
        required: true,
      },
      message: {
        type: Object,
        required: true,
      },
      files: {
        type: Array,
        default: () => [],
      },
      alwaysNotMine: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isMine() {
        return this.user.id === this.userId && !this.alwaysNotMine;
      },
      user() {
        return this.message.user || this.message.author;
      },
      time() {
        return this.message?.updated_at || this.message?.created_at
          ? time(this.message.updated_at || this.message?.created_at)
          : null;
      },
    },
    methods: {
      get,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .message {
    background: #ffffff;
    max-width: 80%;
    padding: 12px;
    border-radius: 12px 12px 12px 0;

    display: grid;
    grid-column-gap: 10px;
    grid-template-columns: 1fr auto;
    align-items: end;
    word-break: break-word;

    .message-time {
      color: $text-tertiary;
      text-align: end;
    }

    .message-user {
      color: $grey900;
      font-weight: bold;
      font-size: 14px;
    }

    &_my {
      margin: 0 0 0 auto;
      border-radius: 12px 12px 0 12px;
      background-color: $primary;
      color: white;

      .message-time {
        color: white;
      }
    }

    &_from {
      display: flex;
      align-items: flex-end;
    }
  }
</style>
